import React from "react";

const Button = (props) => {
  return (
    <button className="bg-green-500 text-white font-semibold py-2 px-4 border border-green-500 border-transparent rounded hover:bg-green-600">
      {props.data}
    </button>
  );
};

export default Button;
